import React, { FC, useEffect } from 'react';
import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { setCurrentScreenTitle } from '@reducers/header';
import i18n from 'i18n-js';
import EventCharts from '@components/machines/components/eventsChart';
import Utilization from '@components/machines/components/Utilization';
import PerformanceScreensWrapper from '@v2/pages/performance/common/components/PerformanceScreensWrapper';

interface PerformanceUtilizationProps {}

const PerformanceUtilization: FC<PerformanceUtilizationProps> = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setCurrentScreenTitle(i18n.t('Utilization')));
  }, []);

  return (
    <PerformanceScreensWrapper>
      <EventCharts getContentElement={(props) => <Utilization key="Utilization" {...props} />} />
    </PerformanceScreensWrapper>
  );
};

export default PerformanceUtilization;
